import MapChart from './map';

import * as d3 from 'd3';

import Legend from './legend';

class Chart extends MapChart {

	renderChoropleth({
		value = () => undefined, // given d in data, returns the quantitative value
		domain, // [min, max] values; input of color scale
		scale = d3.scaleSequential, // type of color scale
		range = d3.interpolateOranges, // output of color scale
		unknown = "#EFEDE8", // fill color for missing data
		outline = this.projection && this.projection.rotate ? {type: "Sphere"} : null

	}) {
		const V = d3.map(this.data().features, value).map(d => d == null ? NaN : +d);
		
		if (domain === undefined) domain = [0, d3.extent(V)[1]];


		const color = scale(domain, ['#FCF40B', '#fe6d60']);
		if (unknown !== undefined) color.unknown(unknown);
		console.log(color.range());

		this.area.attr("fill", (d, i) => color(+value(d)));

		this.area.classed("inactive", d => !value(d));

		let legend = Legend(color, {title: '% aandeel tweede woningen per gemeente', width: 200});

		this.svg.append("g")
			.attr("transform", "translate(20,20)")
			.append(() => legend);

      // const [[x0, y0], [x1, y1]] = d3.geoPath(this.projection.fitWidth(this.width(), this.data())).bounds(this.data());
      // const dy = Math.ceil(y1 - y0), l = Math.min(Math.ceil(x1 - x0), dy);
      // this.projection.scale(this.projection.scale() * (l - 1) / l).precision(0.2);

      // let height = dy;


		return this;

	}

}

export default Chart;